import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Layout } from 'antd';
import HeaderMenu from 'commons/Layout/HeaderMenu';
import SidebarMenu from 'commons/Layout/SidebarMenu';
import RoutesMap from 'commons/Routes/RoutesMap';
import { AuthContext } from 'context/auth';
import React, { FC, useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Auth from 'routes/Auth';
import './App.less';


const { Header, Sider, Content } = Layout;

const App: FC = () => {
  const { isAuthenticated, appDomain } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false)

  const toggle = () => {
    setCollapsed(!collapsed)
  };

  if (!isAuthenticated) {
    return <Auth />
  }

  return (
    <Layout className='appLayout'>
      <Header className="appHeader">
        <div className="appLogo">
          <NavLink to="/"><b>{appDomain}</b></NavLink>
        </div>
        <div className='toggleMenuButton'>
          <Button type='text' onClick={toggle} icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}></Button>
        </div>
        <HeaderMenu />
      </Header>
      <Layout>
        <Sider width={200} className="site-layout-background" trigger={null} collapsible collapsed={collapsed}>
          <SidebarMenu />
        </Sider>
        <Layout style={{ padding: '0 24px 24px' }}>
          <Content
            className="site-layout-background"
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
            }}
          >
            <RoutesMap />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default App;
